import React from 'react';

import { useAppSelector, useAuthentication, useBreakpoints } from '@pkg/hooks';

import { useNavigationStore } from '@app/store/zustand';

import YatLogoImg from '../../assets/images/logo.png';
import { Icon } from '../Icon';
import { LiquidID } from '../LiquidID';
import { YatPicker } from '../YatPicker';
import { StyledButton } from '../styles';

import { Wrapper, YatLogoLink } from './styles';

interface SidebarTopProps {
    isAuthenticated?: boolean;
}

export const SidebarTop = ({ isAuthenticated }: SidebarTopProps) => {
    const isMinimized = useNavigationStore((state) => state.isMinimized);
    const toggleMobileMenu = useNavigationStore((state) => state.toggleMobileMenu);
    const { showLegacyLiquidID } = useAppSelector((state) => state.featureFlags.features);

    const { isMobile } = useBreakpoints();

    const { handleAuthenticate } = useAuthentication();

    if (showLegacyLiquidID) {
        if (!isAuthenticated) {
            return (
                <Wrapper>
                    <YatLogoLink to="/" $isMinimized={isMinimized && !isMobile}>
                        {(!isMinimized || isMobile) && <img src={YatLogoImg} alt="Yat" />}
                        {isMinimized && !isMobile && <Icon name="logo" />}
                    </YatLogoLink>

                    {!isMinimized && (
                        <StyledButton size="xsmall" onClick={handleAuthenticate}>
                            Sign up <span>or</span> Log in
                        </StyledButton>
                    )}
                </Wrapper>
            );
        }

        return (
            <Wrapper>
                {!isMobile ? (
                    <LiquidID />
                ) : (
                    <YatLogoLink to="/" onClick={() => toggleMobileMenu(false)}>
                        <img src={YatLogoImg} alt="Yat" />
                    </YatLogoLink>
                )}
                {(!isMinimized || isMobile) && <YatPicker />}
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <YatLogoLink to="/" $isMinimized={isMinimized && !isMobile}>
                {(!isMinimized || isMobile) && <img src={YatLogoImg} alt="Yat" />}
                {isMinimized && !isMobile && <Icon name="logo" />}
            </YatLogoLink>

            {!isMinimized && !isAuthenticated && (
                <StyledButton size="xsmall" onClick={handleAuthenticate}>
                    Sign up <span>or</span> Log in
                </StyledButton>
            )}

            {(!isMinimized || isMobile) && isAuthenticated && <YatPicker />}
        </Wrapper>
    );
};
